// "Por qué LigoPay" — split block with a fading slide stage (.lpc).
//
// Slides are cross-faded by toggling .is-on (CSS handles the transition);
// arrows (data-dir ±1) and dots (data-go) switch manually and restart the
// auto-advance timer. Auto-advance never runs under prefers-reduced-motion —
// manual navigation still works. The timer is also suspended while the user
// hovers the block, keeps focus inside it, or scrolls it out of view; those
// three conditions are tracked as flags and resolved by sync(), so leaving
// the block with the keyboard still focused (or scrolling back into view
// while hovering) doesn't restart the cycle behind the user's back.

const AUTOPLAY_MS = 6000

function initPorqueLigopay(root) {
  const slides = Array.from(root.querySelectorAll('.lpc__slide'))
  const dots = Array.from(root.querySelectorAll('.lpc__dot'))
  const arrows = Array.from(root.querySelectorAll('.lpc__arrow'))
  if (slides.length < 2) return

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  let index = 0
  let timer = null
  let hovered = false
  let focused = false
  let visible = true

  function go(n) {
    index = ((n % slides.length) + slides.length) % slides.length
    slides.forEach(function (s, k) {
      s.classList.toggle('is-on', k === index)
    })
    dots.forEach(function (d, k) {
      d.classList.toggle('is-on', k === index)
      d.setAttribute('aria-selected', k === index ? 'true' : 'false')
    })
  }

  function stop() {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  function play() {
    stop()
    timer = setInterval(function () {
      go(index + 1)
    }, AUTOPLAY_MS)
  }

  // Single source of truth for "should the carousel be running right now".
  // restart = true forces a fresh interval (used after a manual click so the
  // user gets a full 6s on the slide they just picked).
  function sync(restart) {
    if (reduce || !visible || hovered || focused) {
      stop()
      return
    }
    if (restart || !timer) play()
  }

  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      go(index + (parseInt(btn.dataset.dir, 10) || 1))
      sync(true)
    })
  })

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      go(parseInt(dot.dataset.go, 10) || 0)
      sync(true)
    })
  })

  root.addEventListener('mouseenter', function () {
    hovered = true
    sync()
  })
  root.addEventListener('mouseleave', function () {
    hovered = false
    sync()
  })
  root.addEventListener('focusin', function (e) {
    // Solo el foco de teclado pausa: un click deja el botón con focus "normal"
    // y sin esta distinción el carrusel quedaría pausado para siempre tras
    // usar una flecha con el mouse.
    let keyboardFocus = true
    try {
      keyboardFocus = e.target.matches(':focus-visible')
    } catch (err) {
      /* selector no soportado → conservador: pausa */
    }
    focused = keyboardFocus
    sync()
  })
  root.addEventListener('focusout', function (e) {
    // focusout also fires while moving between the block's own buttons.
    if (root.contains(e.relatedTarget)) return
    focused = false
    sync()
  })

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      function (entries) {
        visible = entries[0].isIntersecting
        sync()
      },
      { threshold: 0.25 }
    )
    io.observe(root)
  }

  go(0)
  sync()
}

function initPorqueLigopayAll() {
  const roots = document.querySelectorAll('.lpc')
  if (!roots.length) return
  roots.forEach(initPorqueLigopay)
}

if (document.readyState !== 'loading') initPorqueLigopayAll()
else document.addEventListener('DOMContentLoaded', initPorqueLigopayAll)
